<template>

    <!-- Mobile-responsive -->
    <div class="p-desktop reach-area-detail row" :style="`width: ${properties.width}%`">
        <div class="flex-center">
            <div :class="['flex-center icon', Classes().padIcon]">
                <img :src="Icon()" :alt="`Icon - ${area}`" :title="area" width="50" height="50"/>
                <div id="transition-arrow" v-if="ShowTransitionArrow()"></div>
            </div>
            <div class="data flex-y-center row single">
                <div>
                    <p class="area-label">{{ area }}</p>
                    <slot/>
                </div>
            </div>
        </div>
    </div>
    <div class="divider" v-if="area === 'Cause' && showDivider"></div>
    <div class="p-mobile reach-area-detail row" :style="`width: ${properties.width}%`">
        <div :class="['flex-center icon m-span', Classes().padIcon]">
            <img :src="Icon()" :alt="`Icon - ${area}`" :title="area" width="100" height="100"/>
            <div class="data flex-y-center single">
                <p class="area-label">{{ area }}</p>
                <slot/>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "ProjectReachDetail",
    props: {
        area: String,
        cause: String,
        properties: Object,
        showDivider: Boolean,
        reachProperties: Object
    },
    methods: {
        Icon: function() {
            let iconSource;
            if (!this.cause) {
                iconSource = "IconImpact.png";
            } else {
                iconSource = `Causes/Icon${this.cause}.png`;
            }
            return require(`@/assets/Images/${iconSource}`);
        },
        Classes: function() {
            let padIcon = "";
            if (this.properties.totalReach > 1 && this.area === "Cause") {
                padIcon = "pad-icon";
            }
            return { padIcon };
        },
        ShowTransitionArrow: function() {
            return this.area === "Cause" && this.reachProperties.totalReach >= 2;
        }
    }
};
</script>